import {
	PreSubmissionConfigurationStatus,
	BatchMessageTypeEnum,
	IVRFlowTypeEnum,
	TemplateType,
} from "../../common/enum";
import BatchMessageLanguageDetailModel from "./BatchMessageLanguageDetailModel";
import BatchMessageGroupDetailModel from "./BatchMessageGroupDetailModel";
import BatchMessageSchedulingDetailModel from "./BatchMessageSchedulingDetailModel";
import IVRFlowConfigurationModel from "../RequestForHelpTemplates/IVRFlowConfigurationModel";

export class PreSubmissionConfigurationModel {
	public id: string;
	public title: string;
	public type: TemplateType | string;
	public country: string;
	public batchMessageType: BatchMessageTypeEnum | string;
	public totalCost: number;
	public currency: string;
	public rowKey: string;
	public partitionKey: string;
	public status?: PreSubmissionConfigurationStatus | string;
	public fromNumber: string;
	public isAlphaNumericSenderId: boolean;
	public africasTalkingEnabled: boolean;
	public vodafoneEnabled: boolean;
	public ivrFlowType: IVRFlowTypeEnum | string;
	public ivrFlowJson: IVRFlowConfigurationModel | string; // Saves JSON for particular IVR flow
	public ivrFlowURL: string; // Saves blob storage URL for particular IVR flow Json
	public nextScheduledRuns: string[] | string | null; //stores batchmessagingscheduling id for corresponding next message to be sent

	constructor() {
		this.id = "";
		this.title = "";
		this.type = "";
		this.country = "";
		this.batchMessageType = "";
		this.totalCost = 0;
		this.currency = "";
		this.rowKey = "";
		this.partitionKey = "";
		this.fromNumber = "";
		this.isAlphaNumericSenderId = false;
		this.africasTalkingEnabled = false;
		this.ivrFlowType = "";
		this.ivrFlowJson = "";
		this.ivrFlowURL = "";
		this.nextScheduledRuns = null;
		this.vodafoneEnabled = false;
	}
}

export class FetchBatchMessageDetailModel {
	public partitionKey: string;
	public nextScheduledRuns: string[] | null;

	constructor(partitionKey: string, nextScheduledRuns: string[] | null) {
		this.partitionKey = partitionKey;
		this.nextScheduledRuns = nextScheduledRuns;
	}
}

export default class BatchMessageDetailModel extends PreSubmissionConfigurationModel {
	public batchMessageLanguageDetail: BatchMessageLanguageDetailModel | null;
	public batchMessageGroupDetail: BatchMessageGroupDetailModel | null;
	public batchMessageSchedulingDetail: BatchMessageSchedulingDetailModel | null;

	constructor() {
		super();
		this.batchMessageLanguageDetail = null;
		this.batchMessageGroupDetail = new BatchMessageGroupDetailModel();
		this.batchMessageSchedulingDetail = null;
	}
}
